export const Types = {
  GET_REQUEST: 'globals-status-actions/GET_REQUEST',
  GET_REQUEST_PREMIUM: 'globals-status-actions/GET_REQUEST_PREMIUM',
  GET_REQUEST_EXCLUSIVE: 'globals-status-actions/GET_REQUEST_EXCLUSIVE',
  GET_SUCCESS: 'globals-status-actions/GET_SUCCESS',
  GET_FAILURE: 'globals-status-actions/GET_FAILURE',
};

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true, error: null };
    case Types.GET_REQUEST_PREMIUM:
      return { ...state, loading: true, error: null };
    case Types.GET_REQUEST_EXCLUSIVE:
      return { ...state, loading: true, error: null };
    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload ? action.payload : state.data,
        loading: false,
        error: null,
      };
    case Types.GET_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  getRequest: formData => ({
    type: Types.GET_REQUEST,
    payload: formData,
  }),
  getRequestExclusive: formData => ({
    type: Types.GET_REQUEST_EXCLUSIVE,
    payload: formData,
  }),
  getRequestPremium: formData => ({
    type: Types.GET_REQUEST_PREMIUM,
    payload: formData,
  }),
  getSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: data,
  }),
  getFailure: error => ({
    type: Types.GET_FAILURE,
    payload: error,
  }),
};
